module.exports = __webpack_public_path__ + "static/media/Micro-bande logiciel.826714c1.jpg";